/**
 * Utilities for calculating health metrics in UserLevels dashboard.
 */

/**
 * Calculates the percentage of records exceeding a target value.
 * @param {Array} data Array of objects with blood pressure values
 * @param {string} field Field name to check ('bloodPressure' or 'bloodPressure1')
 * @param {number|string} targetValue Value to compare against
 * @returns {number} Percentage (0-100)
 */
export const calculatePressureLoad = (data, field, targetValue) => {
  if (!data || data.length === 0) return 0;
  
  const target = parseFloat(targetValue);
  if (isNaN(target)) return 0;

  const count = data.reduce((n, x) => n + (x[field] > target ? 1 : 0), 0);
  return (count * 100) / data.length;
};

/**
 * Calculates statistical proms (avg, min, 25th, 75th, max) for blood pressure.
 * @param {Array} data dataPressure array
 * @param {string} field Field name ('bloodPressure' or 'bloodPressure1')
 * @returns {Array} [avg, min, 25th, 75th, max]
 */
export const calculatePressureStats = (data, field) => {
  if (!data || data.length === 0) return [0, 0, 0, 0, 0];

  const sortedValues = data
    .map(d => d[field])
    .sort((a, b) => a - b);

  const sum = sortedValues.reduce((a, v) => a + v, 0);
  const avg = sum / sortedValues.length;
  
  const min = sortedValues[0];
  const p25 = sortedValues[Math.round((sortedValues.length) / 4)] || min;
  const p75 = sortedValues[Math.round(((sortedValues.length) / 4) * 3)] || sortedValues[sortedValues.length - 1];
  const max = sortedValues[sortedValues.length - 1];

  return [avg, min, p25, p75, max];
};

/**
 * Formats userData to dataPressure structure used in charts and tables.
 * Maintains the legacy +20 logic for bloodPressure1.
 * @param {Array} userData 
 * @returns {Array}
 */
export const formatPressureData = (userData) => {
  return (userData || []).map(d => ({
    date: d.HistoryDate,
    bloodPressure: parseInt(d.Valor),
    bloodPressure1: parseInt(d.Valor) + 20
  }));
};
